import TitleContainer from '../../layout/title/TitleContainer';
import ImageCard from './ImageCard';
import styles from './ImageCardList.module.scss';

const ImageCardList = ({ data, breakpoint }) => {
	const { contentTitle, espotsList } = data;

	return data ? (
		<div className={styles.container} data-test-id="image-card-list-container">
			<TitleContainer label={contentTitle}>
				<div className={`${styles.list} ${styles[breakpoint] || ''}`} data-test-id="image-card-list">
					{espotsList?.map((item) => (
						<ImageCard key={item._id} data={item.espot} breakpoint={breakpoint} />
					))}
				</div>
			</TitleContainer>
		</div>
	) : null;
};

export default ImageCardList;
